import React from "react";

const ListIcon = ({ width = 17, height = 17, fill = "#8126DB", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4995 2.66406V16.6641H2.49951V2.66406H16.4995ZM17.5995 0.664062H1.39951C0.899512 0.664062 0.499512 1.06406 0.499512 1.56406V17.7641C0.499512 18.1641 0.899512 18.6641 1.39951 18.6641H17.5995C17.9995 18.6641 18.4995 18.1641 18.4995 17.7641V1.56406C18.4995 1.06406 17.9995 0.664062 17.5995 0.664062ZM8.49951 4.66406H14.4995V6.66406H8.49951V4.66406ZM8.49951 8.66406H14.4995V10.6641H8.49951V8.66406ZM8.49951 12.6641H14.4995V14.6641H8.49951V12.6641ZM4.49951 4.66406H6.49951V6.66406H4.49951V4.66406ZM4.49951 8.66406H6.49951V10.6641H4.49951V8.66406ZM4.49951 12.6641H6.49951V14.6641H4.49951V12.6641Z"
      fill={fill}
    />
  </svg>
);

export default ListIcon;
